import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource-variable/archivo/wdth.css';
import '@fontsource/geist-sans';
import '@fontsource/geist-mono';
import './styles/global.css';
import './styles/f4-shared.css';
import './styles/dashboard.css';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
